import { adaptEventToCustomEvent } from './adapters/adaptEventToCustomEvent';
import { getAnalyticsConfig } from '../shared/config/getAnalyticsConfig';
import { trackWithGoogleAnalytics } from '../shared/trackers/trackWithGoogleAnalytics';
import { IEvent } from './models/IEvent';

/**
 * Besides built-in events GA4 supports Custom Events, which will need to be configured before showing up in the reports.
 * See: https://support.google.com/analytics/answer/10085872?hl=en
 */
export function trackCustomEvent(event: IEvent) {
	const { name, sendTo, ...rest } = adaptEventToCustomEvent(event);
	const { trackingId } = getAnalyticsConfig();

	if (!trackingId && !sendTo) {
		return;
	}

	trackWithGoogleAnalytics('event', name, {
		send_to: sendTo ?? trackingId,
		...rest,
	});
}
